import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import Layout from '../Components/Layout';
import Signup from '../Components/Signup/Signup';
import Login from '../Components/Login/Login';
import ForgotPassword from '../Components/Login/ForgotPassword';
import Dashboard from '../Components/Dashboard/Dashboard';
import DashboardHome from '../Components/Dashboard/Home.jsx/Home';
import Booking from '../Components/Dashboard/Bookings/Booking';
import Priority from '../Components/Dashboard/PriorityDM/Priority';
import Payments from '../Components/Dashboard/Payments/Payments';
import PageNotFound from "../Pages/PageNotFound/PageNotFound";
import PrivacyAndPolicy from "../Pages/PrivacyAndPolicy/PrivacyAndPolicy";
import RefundPolicy from "../Pages/RefundPolicy/RefundPolicy";
import MentorDetails from "../Components/Mentor/MentorDetails/MentorDetails";
import Contact from "../Components/Contact/Contact";
import MentorOnboarding from "../Components/Signup/MentorOnboarding/MentorOnboarding";
import CreateNewPassword from "../Components/Login/CreateNewPassword";
import Sessions from "../Components/Dashboard/Services/Sessions";
import MentorsList from "../Components/Mentor/MentorsList/MentorsList";
import Careers from "../Components/Careers/Careers";
import Account from "../Components/Dashboard/Account/Account";
import PreviewBookingDetails from "../Components/Mentor/PreviewBookingDetails/PreviewBookingDetails";
import Rewards from "../Components/Dashboard/Rewards/Rewards";
import Home from "../LandingPages/Home/Home";
import JobList from "../Components/Careers/JobList/JobList";
import JobDetail from "../Components/Careers/JobList/Jobdetail";
import JobForm from "../Components/Careers/JobList/JobForm";
import About from "../Components/About/About";
import Room from "../Components/Dashboard/Bookings/MeetingRoom";
import ReviewForm from "../Components/Dashboard/Bookings/ReviewForm";
import LoginRedirectWrapper from './ProtectedRoute';
import BhopalFirstEvent from "../Pages/CodeQueueEvents/BhopalFirstEvent";
import BhopalEventForm from "../Pages/CodeQueueEvents/BhopalEventForm";
import Contest from "../Pages/CodeQueueEvents/Contest";
import OnlineCompiler from "../Components/OnlinePractice/OnlineCompiler/OnlineCompiler";
import ReferralRequest from "../Components/Mentor/MentorPricing/ReferralRequest";
import PriorityDM from "../Components/Mentor/MentorPricing/PriorityDM";
import ChooseUserType from "../Components/OnlinePractice/CodingContest/ChooseUserType";
import Referral from "../Components/Dashboard/Referral/Referral";
import MentorProtectedRoute from "./MentorProtectedRoute";

const Routes = () => {
    const { token } = useAuth();

    const routesForPublic = [
        {
            path: "/",
            element: <Layout><Home /></Layout>, // Wrap with Layout
        },

        {
            path: "*",
            element: <Layout><PageNotFound /></Layout>
        },
        {
            path: "/privacy-and-policy",
            element: <Layout><PrivacyAndPolicy /></Layout>
        },
        {
            path: "/refund-policy",
            element: <Layout><RefundPolicy /></Layout>
        },
        {
            path: "/jobs",
            element: <Layout><JobList /></Layout>
        },
        {
            path: "/jobs/:jobId", // Add the JobDetail route
            element: <Layout><JobDetail /></Layout>,
        },
        {
            path: "/jobs/:jobId/apply", // Adding route for JobForm
            element: <Layout><JobForm /></Layout>,
        },
        {
            path: "/mentors-list",
            element: <Layout><MentorsList /></Layout>,
            children: [
                {
                    path: "details",
                    element: <MentorDetails />
                }
            ]
        },
        {
            path: "/contact",
            element: <Layout><Contact /></Layout>
        },
        {
            path: "/careers",
            element: <Layout><Careers /></Layout>
        },
        {
            path: "/about",
            element: <Layout><About /></Layout>
        },
        {
            path: "/onboarding",
            element: <Layout><MentorOnboarding /></Layout>
        },
        {
            path: "/room/",
            element: <Room />,
        },
        {
            path: "/room/review/",
            element: <ReviewForm />
        },
        {
            path: "/login",
            element: (
                <LoginRedirectWrapper>
                    <Layout><Login /></Layout>
                </LoginRedirectWrapper>
            ),
        },
        {
            path: "/signup",
            element: (
                <LoginRedirectWrapper>
                    <Layout><Signup /></Layout>
                </LoginRedirectWrapper>
            ),
        },
        {
            path: "/forgot-password",
            element: (
                <LoginRedirectWrapper>
                    <Layout><ForgotPassword /></Layout>
                </LoginRedirectWrapper>
            ),
        },
        {
            path: "/new-password",
            element: (
                <LoginRedirectWrapper>
                    <Layout><CreateNewPassword /></Layout>
                </LoginRedirectWrapper>
            ),
        },
        {
            path: "/online-compiler",
            element: <Layout><OnlineCompiler /></Layout>
        },
        {
            path: "/coding-contest",
            element: <Layout><ChooseUserType /></Layout>
        },
        // {
        //     path : "codequeue-contest",
        //     element: <Layout><BhopalFirstEvent /></Layout>
        // },
        {
            path : "referral-request",
            element: <ReferralRequest />
        },
        {
            path : "priority-dm",
            element: <PriorityDM />
        },
    ];

    const routesForAuthenticatedOnly = [
        {
            path: "/",
            element: <ProtectedRoute />,
            children: [
                {
                    path: "/dashboard",
                    element: <Layout><Dashboard /></Layout>, // Wrap with Layout
                    children: [
                        {
                            index: true, // This indicates that this route is the default for its parent
                            element: <Navigate replace to="home" />, // Redirects to 'home'
                        },
                        {
                            path: "home",
                            element: <DashboardHome />,
                        },
                        {
                            path: "bookings",
                            element: <Booking />,
                        },
                        {
                            path: "sessions",
                            element: <Sessions />
                        },
                        {
                            path: "prioritydm",
                            element: <MentorProtectedRoute />,
                            children: [
                                { index: true, element: <Priority /> }
                            ]
                        },
                        {
                            path: "referral",
                            element: <MentorProtectedRoute />,
                            children: [
                                { index: true, element: <Referral /> }
                            ]
                        },
                        {
                            path: "payments",
                            element: <MentorProtectedRoute />,
                            children: [
                                { index: true, element: <Payments /> }
                            ]
                        },
                        {
                            path: "account",
                            element: <Account />
                        },
                        {
                            path: "rewards",
                            element: <Rewards />
                        },
                        {
                            path: "contest",
                            element: <Contest />
                        }
                    ],
                },
                {
                    path: "preview-bookings",
                    element: <Layout><PreviewBookingDetails /></Layout>
                },
                {
                    path : "/codequeue-contest/form",
                    element : <Layout><BhopalEventForm /></Layout>
                }
            ],
        }
    ];

    const routesForNotAuthenticatedOnly = [

        {
            path: "/login",
            element: <Layout><Login /></Layout>, // Wrap with Layout
        },
        {
            path: "/signup",
            element: <Layout><Signup /></Layout>, // Wrap with Layout
        },
        {
            path: "/forgot-password",
            element: <Layout><ForgotPassword /></Layout>
        },
        {
            path: "/new-password",
            element: <Layout><CreateNewPassword /></Layout>
        }
    ];

    const router = createBrowserRouter([
        ...routesForPublic,
        ...routesForAuthenticatedOnly,
        ...(!token ? routesForNotAuthenticatedOnly : []),

    ]);

    return <RouterProvider router={router} />;
};

export default Routes;
